// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1fVrE","file":"styles_file__4TjRU"};